import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, inject } from '@angular/core';
import { PythonTestCaseComponent } from '../python-test-case/python-test-case';

@Component({
  selector: 'skypro-python-test-case-input',
  template: `
    <div [hidden]="true">
      <ng-content></ng-content>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PythonTestCaseInputComponent implements AfterViewInit {
  private pythonTestCaseComponent = inject(PythonTestCaseComponent);
  private elementRef = inject(ElementRef<HTMLElement>);

  ngAfterViewInit(): void {
    const input = this.elementRef.nativeElement.textContent?.trim() || '';
    this.pythonTestCaseComponent.addInput(input);
  }
}
